function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M36 37.72H34.48C32.88 37.72 31.36 38.34 30.24 39.46L26.8199 42.84C25.2599 44.38 22.72 44.38 21.16 42.84L17.74 39.46C16.62 38.34 15.08 37.72 13.5 37.72H12C8.68 37.72 6 35.06 6 31.78V9.94C6 6.66 8.68 4 12 4H36C39.32 4 42 6.66 42 9.94V31.76C42 35.04 39.32 37.72 36 37.72Z",
  stroke: "white",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M24.1399 17.9C24.0599 17.9 23.9398 17.9 23.8398 17.9C21.7398 17.82 20.0798 16.12 20.0798 14C20.0798 11.84 21.8199 10.1 23.9799 10.1C26.1399 10.1 27.8799 11.86 27.8799 14C27.8999 16.12 26.2399 17.84 24.1399 17.9Z",
  stroke: "white",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M18.4999 23.9199C15.8399 25.6999 15.8399 28.5999 18.4999 30.3799C21.5199 32.3999 26.4799 32.3999 29.4999 30.3799C32.1599 28.5999 32.1599 25.6999 29.4999 23.9199C26.4799 21.9199 21.5399 21.9199 18.4999 23.9199Z",
  stroke: "white",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgConsultancyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsultancyIcon);
export default __webpack_public_path__ + "static/media/consultancyIcon.3fa22ca1.svg";
export { ForwardRef as ReactComponent };